// extracted by mini-css-extract-plugin
export default {"MonthsNavigation":"_3mXfK","activeMonthBox":"D6mVW","wrap":"aX-Dx","months":"_7FCQA","month":"plNPA","year":"_0Vf2b","skeleton-progress":"-vS-q"};